var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68904 0.911453H14.495C18.087 0.911453 21 3.82437 21 7.41641V15.2224C21 18.8144 18.087 21.7273 14.495 21.7273H6.68904C3.097 21.7273 0.184082 18.8144 0.184082 15.2224V7.41641C0.184082 3.82437 3.097 0.911453 6.68904 0.911453ZM14.4943 19.7758C17.0053 19.7758 19.0478 17.7333 19.0478 15.2224V7.41641C19.0478 4.90549 17.0053 2.86294 14.4943 2.86294H6.68839C4.17748 2.86294 2.13492 4.90549 2.13492 7.41641V15.2224C2.13492 17.7333 4.17748 19.7758 6.68839 19.7758H14.4943Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38794 11.3194C5.38794 8.44546 7.71802 6.11539 10.5919 6.11539C13.4658 6.11539 15.7959 8.44546 15.7959 11.3194C15.7959 14.1932 13.4658 16.5233 10.5919 16.5233C7.71802 16.5233 5.38794 14.1932 5.38794 11.3194ZM7.33887 11.3193C7.33887 13.1121 8.79859 14.5718 10.5914 14.5718C12.3841 14.5718 13.8438 13.1121 13.8438 11.3193C13.8438 9.52528 12.3841 8.06687 10.5914 8.06687C8.79859 8.06687 7.33887 9.52528 7.33887 11.3193Z",
    fill: "#FEFEFE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1863,
    cy: 5.7252,
    r: 0.693429,
    fill: "#FEFEFE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3b3a494151b4c1a2c3d2d32036a3fcf9.svg";
export { ForwardRef as ReactComponent };